import '../Styles/HistogramStyles.css';
import { Component } from 'preact';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import $ from 'jquery';
import Button from 'react-bootstrap/Button';
class HistogramComponent extends Component {

  constructor(props){
    super(props)
    this.state = {
      flag:1, //Flag para trasladar los puntos con respecto a los ejes del starplot una unica vez
      titleDropDown:"SiO2",
      show:false,
    }
    this.update_histogramAllData = this.update_histogramAllData.bind(this);
  }

  componentDidMount(){
/*
    // set the dimensions and margins of the graph
      var margin = {top: 15, right: 10, bottom: 0, left: 20},
          width = 95 - margin.left - margin.right,
          height = 85 - margin.top - margin.bottom;

    //V2 no (Feo)
    const options = ["TiO2","Al2O3","Cr2O3","Fe2O3","FeO","MnO","MgO"];


    // append the svg object to the body of the page
    let i = 0;
    options.forEach(function(item, fil) {
      options.forEach(function(it, col){
        if(col<=fil){
          var svg = d3.select("#container"+i)
            .append("svg")
              .attr("width", "100%")
              .attr("height", "100%")
            .append("g")
              .attr("transform",
                    "translate(" + margin.left + "," + 4 + ")");


           // Definir la escala x el eje X
          var xScale = d3.scaleLinear()
              .domain([0, 100])
              .range([0, width]);

          var xAxis = d3.axisBottom(xScale)
              .ticks(5); // Mostrar 5 ticks en el eje X

          // Añadir el eje X al gráfico
          svg.append("g")
              .attr("transform", "translate(0," + height + ")")
              .call(xAxis);


          // Definir la escala y el eje Y
          var yScale = d3.scaleLinear()
              .domain([0, 100])
              .range([height, 0]);

          var yAxis = d3.axisLeft(yScale)
              .ticks(1); // Mostrar 5 ticks en el eje X

          // Añadir el eje Y al gráfico
          svg.append("g")
              .call(yAxis)

          if(col == 0){
            // Y label
            svg.append('text')
              .attr('text-anchor', 'middle')
              .attr("class", "labelsAxis")
              .attr('transform', 'translate(-10,' + height/2 + ')rotate(-90)')
              .style('font-family', "'Nunito', sans-serif")
              .style('font-size', 10)
              .text(''+item);
          }
          if(fil == 6){
            // Y label
            svg.append('text')
              .attr("class", "labelsAxis")
              .attr('text-anchor', 'middle')
              .attr('x', width/2)
              .attr('y', height+30)
              .style('font-family', "'Nunito', sans-serif")
              .style('font-size', 10)
              .text(''+it);
          }
        }

        i++;
      });
    });

    var div1Content = document.getElementById("container0").innerHTML;

    var miDiv = document.getElementById("container13");
    miDiv.innerHTML = div1Content;

    var svg = d3.select("#container13")
      .select("svg")
        .attr("width", 250)
        .attr("height", 250)
      .select("g")
        .attr("transform", "translate("  + 80 + "," + 40 + ") scale(" + 2.3 + ")")

  svg.selectAll('.labelsAxis').remove()
  // Y label
  svg.append('text')
      .attr("class", "labelsAxis")
      .attr('text-anchor', 'middle')
      .attr('transform', 'translate(-10,' + 40 + ')rotate(-90)')
      .style('font-family', "'Nunito', sans-serif")
      .style('font-size', 10)
      .text('Frequency');

  // X label
  svg.append('text')
      .attr("class", "labelsAxis")
      .attr('text-anchor', 'middle')
      .attr('transform', 'translate('+35+',' + 90 + ')')
      .style('font-family', "'Nunito', sans-serif")
      .style('font-size', 10)
      .text('TiO2');

    var svglegend = d3.select("#legend")
      .append("svg")
        .attr("width", "100%")
        .attr("height", "100%")
      .append("g")

    svglegend.append("rect").attr("x",120).attr("y",10).attr("width", 10)
    .attr("height", 2).style("fill", "#000000")
    svglegend.append("rect").attr("x",120).attr("y",20).attr("width", 10)
    .attr("height", 2).style("fill", "#B90E0A")
    svglegend.append("text").attr("x", 140).attr("y", 10).text("UMAP selected data").style("font-size", "0.7rem").attr("alignment-baseline","middle")
    svglegend.append("text").attr("x", 140).attr("y", 20).text("Projections selected data").style("font-size", "0.7rem").attr("alignment-baseline","middle")

*/
  }

  //se invoca antes de renderizar cuando se reciben nuevas propiedades o estados
  componentWillReceiveProps(nextProps) {

    if((this.props.complete_data.length!=nextProps.complete_data.length) || (this.props.filteredData_panel.length!=nextProps.filteredData_panel.length) ||
      (this.props.filteredData_umap.length!=nextProps.filteredData_umap.length) || (this.props.filteredData_projection.length!=nextProps.filteredData_umap.length))
      this.update_histogramAllData(nextProps);

  }

  /*
  * Método para dibujar el Histograma con los datos seleccionados en ConfigureComponent
  */
  update_histogramAllData(props){
    var data = [];
    var filteredData_panel = props.filteredData_panel;
    for(let i = 0; i<filteredData_panel.length;i++){
      data.push({
        i: props.complete_data[filteredData_panel[i]].i,
        'TiO2': parseFloat(props.complete_data[filteredData_panel[i]]['TiO2']),
        'Al2O3': parseFloat(props.complete_data[filteredData_panel[i]]['Al2O3']),
        'Cr2O3': parseFloat(props.complete_data[filteredData_panel[i]]['Cr2O3']),
        'Fe2O3': parseFloat(props.complete_data[filteredData_panel[i]]['Fe2O3']),
        'FeO': parseFloat(props.complete_data[filteredData_panel[i]]['FeO']),
        'MnO': parseFloat(props.complete_data[filteredData_panel[i]]['MnO']),
        'MgO': parseFloat(props.complete_data[filteredData_panel[i]]['MgO']),
        Category1: props.complete_data[filteredData_panel[i]].Category1,
      })
    }

    var scaleColor = d3.scaleOrdinal()
    .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Laterite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
    .range(["#7986cb","#f06292", "#ff8a65", "#ffb74d", "#fff176", "#aed581", "#4db6ac","#64b5f6", "#ba68c8","#000000"])


    // set the dimensions and margins of the graph
      var margin = {top: 15, right: 10, bottom: 0, left: 20},
          width = 95 - margin.left - margin.right,
          height = 85 - margin.top - margin.bottom;

      //V2 no (Feo)
      const options = ["TiO2","Al2O3","Cr2O3","Fe2O3","FeO","MnO","MgO"];


      // append the svg object to the body of the page
      let i = 0;
      options.forEach(function(item, fil) {
        options.forEach(function(it, col){
          if(col<=fil){
            d3.select("#container"+i).selectAll(".circles").remove()
            d3.select("#container"+i).selectAll(".rect").remove()

            var svg = d3.select("#container"+i)
              .select("svg")
                .attr("width", "100%")
                .attr("height", "100%")
              .select("g")
                .attr("transform",
                      "translate(" + margin.left + "," + 4 + ")");

             // Definir la escala x el eje X
            var xScale = d3.scaleLinear()
                .domain([0, 100])
                .range([0, width]);

            // Definir la escala y el eje Y
            var yScale = d3.scaleLinear()
                .domain([0, 100])
                .range([height, 0]);


            if(data.length>0){
              if( fil !=  col){
                svg.append('g')
                  .selectAll("dot")
                  .data(data)
                  .enter()
                  .append("circle")
                    .attr("class", "circles")
                    .attr("cx", function (d) { return xScale(d[""+it]); } )
                    .attr("cy", function (d) { return yScale(d[""+item]); } )
                    .attr("r", 1)
                    .style("fill", function(d){return scaleColor(d.Category1);})
                    .style("opacity",0.3);
              }
              else {
                //Read the data
                // Add dots

                // Definir la escala y el eje Y
                yScale = d3.scaleLinear()
                    .domain([0, props.filteredData_panel.length])
                    .range([height, 0]);

                let dd = [];

                //data.forEach(function(elem, i) {dd.push(data[i][""+item])});
                var categoryOrder = d3.scaleOrdinal()
                .domain(["Alaskan ultramafic","Alkali/Lamprophyres","Basalt","Komatiite","Laterite","Layered intrusion","Metamorphic","Ophiolite","Xenoliths"])
                .range([0,1,2,3,4,5,6,7,8])

                let arr = [[],[],[],[],[],[],[],[],[]];
                let seleccionadosUMAP = [],seleccionadosProj=[];
                data.forEach(function(elem, i) {
                  if(props.filteredData_umap.includes(data[i].i))
                    seleccionadosUMAP.push(data[i][""+item]);

                  if(props.filteredData_projection.includes(data[i].i))
                      seleccionadosProj.push(data[i][""+item]);

                  arr[categoryOrder(data[i].Category1)].push(data[i][""+item])
                });

                const x = d3.scaleLinear()
                  .domain([0,100])
                  .range([0, 100]);

                const histogram = d3.histogram()
                  .value(d => d)
                  .domain(x.domain())
                  .thresholds(x.ticks(10));

                let bins = [];
                arr.forEach(function(elem, i) {bins.push(histogram(elem))});


                var bins3 = [
                  { intervalo:"0-10", x0: 0, x1: 10, length:bins[0][0].length,length1:bins[1][0].length,length2:bins[2][0].length,
                                                     length3:bins[3][0].length,length4:bins[4][0].length,length5:bins[5][0].length,
                                                     length6:bins[6][0].length,length7:bins[7][0].length,length8:bins[8][0].length},
                  { intervalo:"10-20", x0: 10, x1: 20, length:bins[0][1].length,length1:bins[1][1].length,length2:bins[2][1].length,
                                                      length3:bins[3][1].length,length4:bins[4][1].length,length5:bins[5][1].length,
                                                      length6:bins[6][1].length,length7:bins[7][1].length,length8:bins[8][1].length},
                  { intervalo:"20-30", x0: 20, x1: 30, length:bins[0][2].length,length1:bins[1][2].length,length2:bins[2][2].length,
                                                      length3:bins[3][2].length,length4:bins[4][2].length,length5:bins[5][2].length,
                                                      length6:bins[6][2].length,length7:bins[7][2].length,length8:bins[8][2].length},
                  { intervalo:"30-40", x0: 30, x1: 40, length:bins[0][3].length,length1:bins[1][3].length,length2:bins[2][3].length,
                                                      length3:bins[3][3].length,length4:bins[4][3].length,length5:bins[5][3].length,
                                                      length6:bins[6][3].length,length7:bins[7][3].length,length8:bins[8][3].length},
                  { intervalo:"40-50", x0: 40, x1: 50, length:bins[0][4].length,length1:bins[1][4].length,length2:bins[2][4].length,
                                                      length3:bins[3][4].length,length4:bins[4][4].length,length5:bins[5][4].length,
                                                      length6:bins[6][4].length,length7:bins[7][4].length,length8:bins[8][4].length},
                  { intervalo:"50-60", x0: 50, x1: 60, length:bins[0][5].length,length1:bins[1][5].length,length2:bins[2][5].length,
                                                      length3:bins[3][5].length,length4:bins[4][5].length,length5:bins[5][5].length,
                                                      length6:bins[6][5].length,length7:bins[7][5].length,length8:bins[8][5].length},
                  { intervalo:"60-70", x0: 60, x1: 70, length:bins[0][6].length,length1:bins[1][6].length,length2:bins[2][6].length,
                                                      length3:bins[3][6].length,length4:bins[4][6].length,length5:bins[5][6].length,
                                                      length6:bins[6][6].length,length7:bins[7][6].length,length8:bins[8][6].length},
                  { intervalo:"70-80", x0: 70, x1: 80, length:bins[0][7].length,length1:bins[1][7].length,length2:bins[2][7].length,
                                                      length3:bins[3][7].length,length4:bins[4][7].length,length5:bins[5][7].length,
                                                      length6:bins[6][7].length,length7:bins[7][7].length,length8:bins[8][7].length},
                  { intervalo:"80-90", x0: 80, x1: 90, length:bins[0][8].length,length1:bins[1][8].length,length2:bins[2][8].length,
                                                      length3:bins[3][8].length,length4:bins[4][8].length,length5:bins[5][8].length,
                                                      length6:bins[6][8].length,length7:bins[7][8].length,length8:bins[8][8].length},
                  { intervalo:"90-100", x0: 90, x1: 100, length:bins[0][9].length,length1:bins[1][9].length,length2:bins[2][9].length,
                                                      length3:bins[3][9].length,length4:bins[4][9].length,length5:bins[5][9].length,
                                                      length6:bins[6][9].length,length7:bins[7][9].length,length8:bins[8][9].length}];



                  // Crear grupos para cada serie de datos
                  var groups = svg.append("g").selectAll("rect")
                    .data(bins3)
                    .enter()
                    .append("g")
                    .attr("transform", d => "translate(" + xScale(d.x0) + ",0)");


                  let binsLineUMAP = histogram(seleccionadosUMAP);
                    // Línea
                  const line = d3.line().curve(d3.curveBundle)
                      .x(d => xScale(d.x0))
                      .y(d => yScale(d.length));

                  // Añadir la línea
                  svg.append("path")
                      .datum(binsLineUMAP)
                      .attr("d", line)
                      .attr("class", "rect")
                      .attr("fill", "none")
                      .attr("stroke", "black")
                      .attr("stroke-width", 1);

                  let binsLineProj = histogram(seleccionadosProj);

                  // Añadir la línea
                  svg.append("path")
                      .datum(binsLineProj)
                      .attr("d", line)
                      .attr("class", "rect")
                      .attr("fill", "none")
                      .attr("stroke", "#B90E0A")
                      .attr("stroke-width", 0.8);

                  // Dibujar las barras apiladas para cada serie de datos
                  groups.append("rect")
                    .attr("class", "rect")
                    .attr("y", d => yScale(d.length))
                    .attr("x", 1)
                    .attr("height", d => yScale(0) - yScale(d.length))
                    .attr("width",  function(d) { return xScale(d.x1) - xScale(d.x0)  ; })
                    .style("fill", "#7986cb");

                 groups.append("rect")
                    .attr("class", "rect")
                    .attr("y", d => yScale(d.length + d.length1))
                    .attr("x", 1)
                    .attr("height", d => yScale(d.length) - yScale(d.length + d.length1))
                    .attr("width",  function(d) { return xScale(d.x1) - xScale(d.x0)  ; })
                    .style("fill", "#f06292");


                groups.append("rect")
                  .attr("class", "rect")
                  .attr("y", d => yScale(d.length + d.length1 + d.length2))
                  .attr("x", 1)
                  .attr("height", d => yScale(d.length + d.length1) - yScale(d.length + d.length1 + d.length2))
                  .attr("width",  function(d) { return xScale(d.x1) - xScale(d.x0)  ; })
                  .style("fill", "#ff8a65");


                groups.append("rect")
                  .attr("class", "rect")
                  .attr("y", d => yScale(d.length + d.length1 + d.length2 + d.length3))
                  .attr("x", 1)
                  .attr("height", d => yScale(d.length + d.length1 + d.length2) - yScale(d.length + d.length1 + d.length2 + d.length3))
                  .attr("width",  function(d) { return xScale(d.x1) - xScale(d.x0)  ; })
                  .style("fill", "#ffb74d");

                groups.append("rect")
                  .attr("class", "rect")
                  .attr("y", d => yScale(d.length + d.length1 + d.length2 + d.length3 + d.length4))
                  .attr("x", 1)
                  .attr("height", d => yScale(d.length + d.length1 + d.length2 + d.length3) - yScale(d.length + d.length1 + d.length2 + d.length3+ d.length4))
                  .attr("width",  function(d) { return xScale(d.x1) - xScale(d.x0)  ; })
                  .style("fill", "#fff176");

                groups.append("rect")
                  .attr("class", "rect")
                  .attr("y", d => yScale(d.length + d.length1 + d.length2 + d.length3 + d.length4 +d.length5))
                  .attr("x", 1)
                  .attr("height", d => yScale(d.length + d.length1 + d.length2 + d.length3 + d.length4) - yScale(d.length + d.length1 + d.length2 + d.length3+ d.length4+d.length5))
                  .attr("width",  function(d) { return xScale(d.x1) - xScale(d.x0)  ; })
                  .style("fill", "#aed581");

                groups.append("rect")
                  .attr("class", "rect")
                  .attr("y", d => yScale(d.length + d.length1 + d.length2 + d.length3 + d.length4+d.length5+d.length6))
                  .attr("x", 1)
                  .attr("height", d => yScale(d.length + d.length1 + d.length2 + d.length3 + d.length4 +d.length5) - yScale(d.length + d.length1 + d.length2 + d.length3+ d.length4+d.length5+d.length6))
                  .attr("width",  function(d) { return xScale(d.x1) - xScale(d.x0)  ; })
                  .style("fill", "#4db6ac");

                groups.append("rect")
                  .attr("class", "rect")
                  .attr("y", d => yScale(d.length + d.length1 + d.length2 + d.length3 + d.length4+d.length5+d.length6+d.length7))
                  .attr("x", 1)
                  .attr("height", d => yScale(d.length + d.length1 + d.length2 + d.length3 + d.length4 +d.length5 + d.length6) - yScale(d.length + d.length1 + d.length2 + d.length3+ d.length4+d.length5+d.length6+d.length7))
                  .attr("width",  function(d) { return xScale(d.x1) - xScale(d.x0)  ; })
                  .style("fill", "#64b5f6");


                groups.append("rect")
                  .attr("class", "rect")
                  .attr("y", d => yScale(d.length + d.length1 + d.length2 + d.length3 + d.length4+d.length5+d.length6+d.length7+d.length8))
                  .attr("x", 1)
                  .attr("height", d => yScale(d.length + d.length1 + d.length2 + d.length3 + d.length4 +d.length5 +d.length6+d.length7 ) - yScale(d.length + d.length1 + d.length2 + d.length3+ d.length4+d.length5+d.length6+d.length7+d.length8))
                  .attr("width",  function(d) { return xScale(d.x1) - xScale(d.x0)  ; })
                  .style("fill", "#ba68c8");
              }
            }
          }
          i++;

        })

      })
      var div1Content = document.getElementById("container0").innerHTML;
      // Set the contents of div2 to be the same as div1
      var miDiv = document.getElementById("container13");
      miDiv.innerHTML = div1Content;

      var svg = d3.select("#container13")
        .select("svg")
          .attr("width", 250)
          .attr("height", 250)
        .select("g")
          .attr("transform", "translate("  + 80 + "," + 40 + ") scale(" + 2.3 + ")")

      svg.selectAll('.labelsAxis').remove()

      // Y label
      svg.append('text')
        .attr("class", "labelsAxis")
        .attr('text-anchor', 'middle')
        .attr('transform', 'translate(-10,' + 40 + ')rotate(-90)')
        .style('font-family', "'Nunito', sans-serif")
        .style('font-size', 10)
        .text('Frequency');

      // X label
      svg.append('text')
        .attr("class", "labelsAxis")
        .attr('text-anchor', 'middle')
        .attr('transform', 'translate('+35+',' + 90 + ')')
        .style('font-family', "'Nunito', sans-serif")
        .style('font-size', 10)
        .text('TiO2');

}


actualizarModal(id){
  /*
  var div1Content = document.getElementById("container"+id).innerHTML;
  // Set the contents of div2 to be the same as div1
  var miDiv = document.getElementById("container13");
  miDiv.innerHTML = div1Content;

  var svg = d3.select("#container13")
    .select("svg")
      .attr("width", 250)
      .attr("height", 250)
    .select("g")
      .attr("transform", "translate("  + 80 + "," + 40 + ") scale(" + 2.3 + ")")


  const options = ["TiO2","Al2O3","Cr2O3","Fe2O3","FeO","MnO","MgO"];
  svg.selectAll('.labelsAxis').remove()

  let labely = options[parseInt(id/options.length)];
  let labelx = options[parseInt(id%options.length)];

  if(labely == labelx)
    labely = "Frequency";
  // Y label
  svg.append('text')
    .attr('text-anchor', 'middle')
    .attr('transform', 'translate(-10,' + 40 + ')rotate(-90)')
    .style('font-family', "'Nunito', sans-serif")
    .style('font-size', 10)
    .text(''+labely);


  // X label
  svg.append('text')
    .attr('text-anchor', 'middle')
    .attr('transform', 'translate('+35+',' + 90 + ')')
    .style('font-family', "'Nunito', sans-serif")
    .style('font-size', 10)
    .text(''+labelx);*/
}

render(){
  return (
    <div class="container-Histogram">
      <div class="row">
        <div class="col-lg">

        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(0)}>
          <div id="container0"></div>
        </Button>

        </div>
      </div>
      <div class="row">
        <div class="col-lg">
          <Button className="btn-primary" onClick={(e)=>this.actualizarModal(7)}>
            <div id="container7"></div>
          </Button>
        </div>
        <div class="col-lg">
          <Button className="btn-primary" onClick={(e)=>this.actualizarModal(8)}>
            <div id="container8"></div>
          </Button>
        </div>
        <div class="col-lg">

        </div>
        <div class="col-lg">

        </div>
        <div class="col-lg">

        </div>
        <div class="col-lg">
        <div id="container13"></div>
        <div id="legend"></div>
        </div>
        <div class="col-lg">

        </div>
      </div>
      <div class="row">
        <div class="col-lg">
          <Button className="btn-primary" onClick={(e)=>this.actualizarModal(14)}>
            <div id="container14"></div>
          </Button>
        </div>
        <div class="col-lg">
          <Button className="btn-primary" onClick={(e)=>this.actualizarModal(15)}>
            <div id="container15"></div>
          </Button>
        </div>
        <div class="col-lg">
          <Button className="btn-primary" onClick={(e)=>this.actualizarModal(16)}>
            <div id="container16"></div>
          </Button>
        </div>
        <div class="col-lg">

        </div>
        <div class="col-lg">

        </div>
        <div class="col-lg">

        </div>
        <div class="col-lg">
        </div>
      </div>
      <div class="row">
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(21)}>
          <div id="container21"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(22)}>
          <div id="container22"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(23)}>
          <div id="container23"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(24)}>
          <div id="container24"></div>
        </Button>
      </div>
      <div class="col-lg">

      </div>
      <div class="col-lg">

      </div>
      <div class="col-lg">

      </div>
      </div>
      <div class="row">
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(28)}>
          <div id="container28"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(29)}>
          <div id="container29"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(30)}>
          <div id="container30"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(31)}>
          <div id="container31"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(32)}>
          <div id="container32"></div>
        </Button>
      </div>
      <div class="col-lg">

      </div>
      <div class="col-lg">

      </div>
      </div>
      <div class="row">
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(35)}>
          <div id="container35"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(36)}>
          <div id="container36"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(37)}>
          <div id="container37"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(38)}>
          <div id="container38"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(39)}>
          <div id="container39"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(40)}>
          <div id="container40"></div>
        </Button>
      </div>
      <div class="col-lg">

      </div>
      </div>
      <div class="row">
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(42)}>
          <div id="container42"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(43)}>
          <div id="container43"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(44)}>
          <div id="container44"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(45)}>
          <div id="container45"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(46)}>
          <div id="container46"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(47)}>
          <div id="container47"></div>
        </Button>
      </div>
      <div class="col-lg">
        <Button className="btn-primary" onClick={(e)=>this.actualizarModal(48)}>
          <div id="container48"></div>
        </Button>
      </div>
      </div>
    </div>
  );
}

}
export default HistogramComponent;
